/* 🤖 this file was generated by svg-to-ts*/
export const iconRangeFbn: {
  name: 'range_fbn';
  data: string;
} = {
  name: 'range_fbn',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M8 16a1.07 1.07 0 01-.46-.11C7.28 15.75 1 12.46 1 8V4a1 1 0 011-1C4.5 3 7.27.31 7.3.29a1 1 0 011.4 0S11.5 3 14 3a1 1 0 011 1v4c0 4.46-6.27 7.75-6.54 7.89A1 1 0 018 16zM3 4.91V8c0 2.46 3.27 4.86 5 5.86 1.73-1 5-3.4 5-5.86V4.91a11.66 11.66 0 01-5-2.57 11.66 11.66 0 01-5 2.57z"/><path d="M10 7H9V6a1 1 0 00-2 0v1H6a1 1 0 000 2h1v1a1 1 0 002 0V9h1a1 1 0 000-2z"/></svg>`,
};
